import { render, staticRenderFns } from "./CustomerDataHeadline.vue?vue&type=template&id=738b967d&scoped=true"
import script from "./CustomerDataHeadline.vue?vue&type=script&lang=ts"
export * from "./CustomerDataHeadline.vue?vue&type=script&lang=ts"
import style0 from "./CustomerDataHeadline.vue?vue&type=style&index=0&id=738b967d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738b967d",
  null
  
)

export default component.exports